import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { filterIcon } from '../../../Templates/icons'
import Checkbox from '@material-ui/core/Checkbox';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
}));

export default function MenuListComposition(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <div className={classes.root}>
            <div>
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    {filterIcon}
                </Button>
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList className="flex-column-centered" autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                        <h3>Included Users: </h3>
                                        <MenuItem onClick={(e) => props.handleCheckBox(e,"Artisan")}>Artisans
                                              <Checkbox
                                                checked={props.checkBoxes["Artisan"] ? true : false}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        </MenuItem>
                                        <MenuItem onClick={(e) => props.handleCheckBox(e,"Work Lead")}>Work Leads
                                            <Checkbox
                                                checked={props.checkBoxes["Work Lead"] ? true : false}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        </MenuItem>
                                        <MenuItem onClick={(e) => props.handleCheckBox(e,"Shop Supervisor")}>Shop Supervisors
                                            <Checkbox
                                                checked={props.checkBoxes["Shop Supervisor"] ? true : false}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />    
                                        </MenuItem>
                                        <MenuItem onClick={(e) => props.handleCheckBox(e,"Engineer")}>Engineers
                                            <Checkbox
                                                checked={props.checkBoxes["Engineer"] ? true : false}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />      
                                        </MenuItem>
                                        <MenuItem onClick={(e) => props.handleCheckBox(e,"E&E")}>{"E&Es"}
                                            <Checkbox
                                                checked={props.checkBoxes["E&E"] ? true : false}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />  
                                        </MenuItem>
                                        <MenuItem onClick={(e) => props.handleCheckBox(e,"QA")}>QAs
                                            <Checkbox
                                                checked={props.checkBoxes["QA"] ? true : false}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />  
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </div>
    );
}
